// import React, { useState } from "react";
// import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
// import { IoSearchSharp } from "react-icons/io5";
// import TableMui from "../../components/mui/TableMui";
// import { IconButton, Menu, MenuItem } from "@mui/material";
// import Pagination from "../../components/Pagination";
// import {
//   useDeletePostCommentsOnIdMutation,
//   useGetAllPostCommentsQuery,
// } from "../../redux/clientApi";
// import LoadingScreen from "../LoadingScreen";
// import { useTranslation } from "react-i18next";
// import { getCorrectDate } from "../../utils/helpers";
// import { toast } from "react-toastify";

// const AdminPostComments = () => {
//   const [currentPage, setCurrentPage] = useState(1);
//   const [search, setSearch] = useState("");
//   const { t } = useTranslation();

//   const { data, isLoading } = useGetAllPostCommentsQuery({
//     page: currentPage,
//     search: search,
//   });

//   const pagination = data?.data?.pagination || {};
//   const comments = data?.data?.comments || [];

//   // Table headers with translations
//   const headers = {
//     comment: t("adminPostComments.tableHeaderComment"),
//     "channelId.channelName": t("adminPostComments.tableHeaderChannel"),
//     createdAt: t("adminPostComments.tableHeaderCreatedAt"),
//     actions: t("adminPostComments.tableHeaderActions"),
//   };

//   if (isLoading) {
//     return <LoadingScreen />;
//   }

//   return (
//     <div className="mt-[60px] md:mt-[100px] max-w-[1300px] mx-auto pt-4 pb-12 px-6 sm:px-12 bg-white">
//       {/* Heading + Search bar */}
//       <div className="flex flex-col md:flex-row gap-3 justify-between items-center">
//         <div>
//           <h2 className="text-[20px] sm:text-[24px] md:text-[30px] lg:text-[40px] font-semibold mt-8 md:mt-0">
//             {t("adminPostComments.postCommentsManagement")}
//           </h2>
//           <p className="max-w-[600px] text-[14px] sm:text-[16px]">
//             {t("adminPostComments.manageCommentsDescription")}
//           </p>
//         </div>

//         <div className="flex items-center w-full sm:w-[calc(30%-30px)] p-1 h-10 bg-[#F7F7F7] border border-[#EECB3D] rounded-md">
//           <div className="p-2 bg-[#EECB3D] rounded-md">
//             <IoSearchSharp />
//           </div>
//           <input
//             type="search"
//             value={search}
//             onChange={(e) => {
//               setSearch(e.target.value);
//               setCurrentPage(1);
//             }}
//             placeholder={t("adminPostComments.searchPlaceholder")}
//             className="ml-2 flex-1 p-1 outline-none bg-transparent text-sm"
//           />
//         </div>
//       </div>

//       {/* Table Section */}
//       <div className="mt-12">
//         <TableMui
//           th={headers}
//           td={comments}
//           customFields={[
//             {
//               name: "createdAt",
//               data: (value) => (
//                 <span className="capitalize font-medium">
//                   {getCorrectDate(t, value)}
//                 </span>
//               ),
//             },
//             {
//               name: "actions",
//               data: (_, row) => <ActionMenu row={row} />,
//             },
//           ]}
//         />

//         <Pagination
//           currentPage={currentPage}
//           totalPages={pagination.totalPages || 0}
//           onPageChange={(page) => setCurrentPage(page)}
//         />
//       </div>
//     </div>
//   );
// };

// const ActionMenu = ({ row }) => {
//   const [anchorEl, setAnchorEl] = useState(null);
//   const open = Boolean(anchorEl);
//   const { t } = useTranslation();

//   const [deletePostCommentsOnId] = useDeletePostCommentsOnIdMutation();

//   const handleClick = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleClose = () => {
//     setAnchorEl(null);
//   };

//   const handleDelete = async (postCommentId) => {
//     try {
//       const res = await deletePostCommentsOnId(postCommentId);

//       if (
//         res?.error?.data?.status === "error" ||
//         res?.error?.data?.status === "fail"
//       ) {
//         throw new Error(
//           res?.error?.data?.message || t("adminPostComments.toastDeleteError"),
//         );
//       }

//       const successMessage =
//         res?.message || t("adminPostComments.toastDeleteSuccess");

//       toast.success(successMessage);
//     } catch (error) {
//       // error handling with fallback translation
//       const errorMsg =
//         error?.message || t("adminPostComments.toastDeleteError");

//       toast.error(errorMsg);
//     }

//     handleClose();
//   };

//   return (
//     <div>
//       <IconButton onClick={handleClick}>
//         <PiDotsThreeOutlineVerticalFill />
//       </IconButton>

//       <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
//         <MenuItem onClick={() => handleDelete(row?._id)} sx={{ color: "red" }}>
//           {t("adminPostComments.actionDelete")}
//         </MenuItem>
//       </Menu>
//     </div>
//   );
// };

// export default AdminPostComments;

import React, { useState } from "react";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
import { IoSearchSharp } from "react-icons/io5";
import TableMui from "../../components/mui/TableMui";
import { IconButton, Menu, MenuItem } from "@mui/material";
import Pagination from "../../components/Pagination";
import {
  useDeletePostCommentsOnIdMutation,
  useGetAllPostCommentsQuery,
} from "../../redux/clientApi";
import LoadingScreen from "../LoadingScreen";
import { useTranslation } from "react-i18next";
import { getCorrectDate } from "../../utils/helpers";
import { toast } from "react-toastify";
import DeletionDialog from "../DeletionDialog";

const AdminPostComments = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const { t } = useTranslation();

  const { data, isLoading } = useGetAllPostCommentsQuery({
    page: currentPage,
    search: search,
  });

  const pagination = data?.data?.pagination || {};
  const comments = data?.data?.comments || [];

  const [deletePostComment, { isLoading: isDeleting }] =
    useDeletePostCommentsOnIdMutation();

  const [isDeletionDialogOpen, setIsDeletionDialogOpen] = useState(false);
  const [deletionCommentId, setDeletionCommentId] = useState(null);

  const headers = {
    comment: t("adminPostComments.tableHeaderComment"),
    "channelId.channelName": t("adminPostComments.tableHeaderChannel"),
    createdAt: t("adminPostComments.tableHeaderCreatedAt"),
    actions: t("adminPostComments.tableHeaderActions"),
  };

  const dialogOpen = () => {
    setIsDeletionDialogOpen(true);
  };

  const cancelDelete = () => {
    setIsDeletionDialogOpen(false);
    setDeletionCommentId(null);
  };

  const confirmDelete = async () => {
    if (!deletionCommentId) return;

    try {
      const res = await deletePostComment(deletionCommentId);

      if (
        res?.error?.data?.status === "error" ||
        res?.error?.data?.status === "fail"
      ) {
        throw new Error(
          res?.error?.data?.message || t("adminPostComments.toastDeleteError"),
        );
      }

      const successMessage =
        res?.message || t("adminPostComments.toastDeleteSuccess");

      toast.success(successMessage);
      cancelDelete();
    } catch (error) {
      // error handling with fallback translation
      const errorMsg =
        error?.message || t("adminPostComments.toastDeleteError");

      toast.error(errorMsg);
    }
  };

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <div className="mt-[60px] md:mt-[100px] max-w-[1300px] mx-auto pt-4 pb-12 px-6 sm:px-12 bg-white">
      {/* Heading + Search bar */}
      <div className="flex flex-col md:flex-row gap-3 justify-between items-center">
        <div>
          <h2 className="text-[20px] sm:text-[24px] md:text-[30px] lg:text-[40px] font-semibold mt-8 md:mt-0">
            {t("adminPostComments.postCommentsManagement")}
          </h2>
          <p className="max-w-[600px] text-[14px] sm:text-[16px]">
            {t("adminPostComments.manageCommentsDescription")}
          </p>
        </div>

        <div className="flex items-center w-full sm:w-[calc(30%-30px)] p-1 h-10 bg-[#F7F7F7] border border-[#EECB3D] rounded-md">
          <div className="p-2 bg-[#EECB3D] rounded-md">
            <IoSearchSharp />
          </div>
          <input
            type="search"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1);
            }}
            placeholder={t("adminPostComments.searchPlaceholder")}
            className="ml-2 flex-1 p-1 outline-none bg-transparent text-sm"
          />
        </div>
      </div>

      {/* Table Section */}
      <div className="mt-12">
        <TableMui
          th={headers}
          td={comments}
          customFields={[
            {
              name: "createdAt",
              data: (value) => (
                <span className="capitalize font-medium">
                  {getCorrectDate(t, value)}
                </span>
              ),
            },
            {
              name: "actions",
              data: (_, row) => (
                <ActionMenu
                  row={row}
                  dialogOpen={dialogOpen}
                  setDeletionCommentId={setDeletionCommentId}
                />
              ),
            },
          ]}
        />

        <Pagination
          currentPage={currentPage}
          totalPages={pagination.totalPages || 0}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </div>

      {/* Reusable Deletion Dialog */}
      <DeletionDialog
        open={isDeletionDialogOpen}
        onClose={cancelDelete}
        onConfirm={confirmDelete}
        isDeleting={isDeleting}
        title="admin-places.dialog.title"
        message="admin-places.dialog.message"
        confirmText="admin-places.dialog.confirm"
        cancelText="admin-places.dialog.cancel"
      />
    </div>
  );
};

const ActionMenu = ({ row, dialogOpen, setDeletionCommentId }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const { t } = useTranslation();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDeleteClick = () => {
    setDeletionCommentId(row?._id);
    dialogOpen();
    handleClose();
  };

  return (
    <div>
      <IconButton onClick={handleClick}>
        <PiDotsThreeOutlineVerticalFill />
      </IconButton>

      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={handleDeleteClick} sx={{ color: "red" }}>
          {t("adminPostComments.actionDelete")}
        </MenuItem>
      </Menu>
    </div>
  );
};

export default AdminPostComments;
